export const API_HOST = "https://twittgo-co.herokuapp.com"


export const AVATAR_NOT_FOUND = "https://4.bp.blogspot.com/-CuZOfJdrDKY/UYmig8q88yI/AAAAAAAAEZM/bzVtIKPhXVA/s1600/Satoshi-nakamoto.gif"

export const TOKEN = "token"